import { UserStreak } from "../../models/UserStreak";
import { AppMessages } from "../../strings";

function getStreakLabel(userStreak: UserStreak): string {
	const name = userStreak.streak?.name?.trim();
	if (name) {
		return name;
	}
	const typeName = userStreak.streak?.streakType?.name?.trim();
	if (typeName) {
		return typeName;
	}
	return AppMessages.streakUntitled;
}

/**
 * Returns CSS grid layout classes for the streak tile grid based on streak count.
 */
function getStreakTileGridClass(streakCount: number): string {
	if (streakCount === 1) {
		return "streak-tile-grid streak-tile-grid--single";
	}
	return "streak-tile-grid streak-tile-grid--multi";
}

const StreakTile = ({ userStreak }: { userStreak: UserStreak }) => {
	const label = getStreakLabel(userStreak);
	const currentDays = userStreak.currentStreakDays;
	const longestDays = userStreak.longestStreakDays;
	const showLongest = longestDays != null;
	const tileClassName = showLongest
		? "tile streak-tile-card streak-tile-card--with-longest"
		: "tile streak-tile-card";

	return (
		<div className={tileClassName}>
			<div className="streak-tile-content">
				<div className="streak-tile-label fw-semibold" title={label}>
					{label}
				</div>
				<div className="streak-tile-days">
					<span>{currentDays ?? "-"}</span>
				</div>
				{showLongest && (
					<div className="streak-tile-longest">
						{AppMessages.streakLongest}: {longestDays}
					</div>
				)}
			</div>
		</div>
	);
};

const StreakSection = ({ userStreaks }: { userStreaks?: UserStreak[] }) => {
	if (!userStreaks?.length) {
		return null;
	}

	return (
		<div className="row">
			<div className="col-12">
				<div className="card" style={{ marginBottom: "0.35rem" }}>
					<div className="card-body align-items-center streak-section-body">
						<div className={getStreakTileGridClass(userStreaks.length)}>
							<div className="text-center streak-section-title">
								{AppMessages.streaksTitle}
							</div>
							{userStreaks.map((userStreak) => (
								<StreakTile key={userStreak.userStreakID} userStreak={userStreak} />
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default StreakSection;
